import gql from "graphql-tag";

const GET_FORM_SUBMISSION_COUNT = gql`
    query getFormSubmissionCount($input: FormSubmissionFilter){
        getFormSubmissionCount(filter:$input)
    }
`;

export default GET_FORM_SUBMISSION_COUNT;
